export default function throttle (handler: () => void, duration: number): () => void {
  let raf = 0;
  let lastExecutedTime = 0;

  function check () {
    const now = performance.now();
    const elapsedTime = now - lastExecutedTime;

    if (elapsedTime > duration) {
      lastExecutedTime = now;
      handler();
    } else {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(check);
    }
  }

  return () => {
    check();
  };
}
